// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_f7-0";
export var actionModalContentContainer = "_f7-1";
export var createTagButton = "_f7-2";
export var footerContainer = "_f7-7";
export var fullWidthDivider = "_f7-3";
export var hasCreateTagButton = "_f7-4";
export var noCreateTagButton = "_f7-5";
export var tagsContainer = "_f7-6";
export var tagsModalContentContainer = "_f7-8";